module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_hint-e1ed0c05293dec6efb7d114c2e4b3a4d.svg";